export class InvalidSessionConfigSettingError extends Error {
  constructor(settingName: string, value: unknown) {
    super(`Invalid ${settingName} setting: ${value}`)
    Object.setPrototypeOf(this, new.target.prototype)
  }
}

export function assertNumeric(settingName: string, value: unknown) {
  if (typeof value !== "number") {
    throw new InvalidSessionConfigSettingError(settingName, value)
  }
}

export function assertObject(settingName: string, value: unknown) {
  if (typeof value !== "object") {
    throw new InvalidSessionConfigSettingError(settingName, value)
  }
}

export function assertString(settingName: string, value: unknown) {
  if (typeof value !== "string") {
    throw new InvalidSessionConfigSettingError(settingName, value)
  }
}

export function assertNonEmptyString(settingName: string, value: unknown) {
  if (typeof value !== "string" || value.trim().length < 1) {
    throw new InvalidSessionConfigSettingError(settingName, value)
  }
}
